/**
 * moduł wykorzystywany poza sprzedażówkami
 * adress, prezentacja kafelków polis
 * ale nie odpala i nie wymaga dataContainer'a
 */
angular.module('salesPath.outer', [
  'ihestiaRestServicesBase',
  'ihestiaCommonDirectives',
  'ihestiaSalesPathTemplate'
  ]);